// extracted by mini-css-extract-plugin
export var userAvatar = "user-avatar-module--user-avatar--JFvoH";